
export const INSUFFICIENT_TOKENS_MESSAGE = 'INSUFFICIENT TOKENS';